export const newsletterEditions = [
  {
    slug: 'august-2026',
    title: 'August 2026 Edition',
    date: 'August 2026',
    headline: 'The Future of Head Start',
    summary:
      'Our inaugural edition: what the proposed Head Start rule changes could mean for DC, the Play Science Institute, the Stronger Together recap video, and new field resources.',
    cover: 'https://customer-assets-cm19k8pv.emergentagent.net/job_55671c95-2135-4572-a38e-4ba882651c43/artifacts/xuqaf8uj_unnamed.webp',
  },
];
